<!--疑似窜货趋势图-->
<template>
	<div>
		<h3>疑似窜货趋势图</h3>
		<div>
            <div class="lines">
                <el-form ref="form" :model="form" inline :rules="rules">
                    <el-form-item prop="date" style="width: 150px;">
						<el-radio-group v-model="form.date">
                            <el-radio-button label="本月"></el-radio-button>
                            <el-radio-button label="本年"></el-radio-button>
                        </el-radio-group>
					</el-form-item>
                    <el-form-item prop="makeTime" style="width: 360px;padding-top: 1px;">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
                    <el-form-item prop="productForm.Productname" style="width: 210px;">
						<el-input placeholder="全部商品" :value="form.productForm.Productname" @focus="productfocus"></el-input>
					</el-form-item>
                    <el-button @click="restForm" style="margin-top: 1px;" type="warning">重 置</el-button>
                </el-form>
                <div :style="{height:'500px',width:'100%'}" ref="eChart1" id="eChart1"></div>
            </div>
		</div>
        <div class="item">
            <el-button type="primary" style="margin-bottom: 15px;">导 出</el-button>
            <el-table border>
                <el-table-column align="center" property="DataId" label="日期"></el-table-column>
                <el-table-column align="center" property="Productcode" label="疑似窜货数量"></el-table-column>
            </el-table>
        </div>
        
	</div>
</template>

<script>
import echarts from "echarts";//引入图表
export default {
	data(){
		return {
            form:{
                date:'本月',
                makeTime:'',
                productForm:{
					Productcode:'',
					Productname:'',
					Norms:''
				},
            },
            rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
			option1 : {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['2020-01', '2020-02', '2020-03', '2020-04', '2020-05', '2020-06', '2020-07','2020-08','2020-09','2020-10','2020-11','2020-12']
                },
                yAxis: {
                    type: 'value',
                    splitLine:'false'
                },
                series: [
                    {
                        name: '产量',
                        type: 'line',
                        stack: '总量',
                        data: [120, 132, 101, 134, 90, 280, 210],
                        smooth: true,
                        symbol: "none",//去掉曲线上的圆点
                    }
                ]
            },
            
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()

        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("eChart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('eChart1'));
             myChart1.resize();
        });
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.setOption(this.option1); 
        },
        productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
        restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.productForm.Productcode = '';
			this.form.productForm.Productname = '';
			this.form.productForm.Norms = '';
		},
	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/fcTrend.vue